import React from 'react'
import TvComment from "../component/TvComment"
import NavigationBar from '../component/Layout/NavigationBar'
function TvCommentPage() {
  return (
    <>
    <NavigationBar/>
    <TvComment/>
    </>
  )
}

export default TvCommentPage